import { formatDate } from "../../../utils/dateFormatting";
import { View, SxProp } from "dripsy";
import React from "react";
import { TextBody } from "../typography/UniTypography";
import { ProgressBar } from "./ProgressBar";

export interface ProgressStatus {
  name: string;
  date: string;
  status: "active" | "inactive";
  prevStatus?: "active" | "inactive" | null;
  nextStatus?: "active" | "inactive" | null;
  noFormat?: boolean;
}

export interface ProgressItemProps extends ProgressStatus {
  index: number;
}

export const ProgressItem: React.FC<ProgressItemProps> = (props) => {
  const { index, name, date, status, prevStatus, nextStatus, noFormat } = props;

  const isFirst = !prevStatus;
  const isLast = !nextStatus;

  return (
    <View sx={styles.container}>
      {/* Progress Bar */}
      <ProgressBar
        index={index}
        isFirst={isFirst}
        isLast={isLast}
        isActive={status === "active"}
      />
      {/* Details */}
      <View sx={styles.details}>
        <TextBody secondary sx={{ flex: 1 }}>
          {name}
        </TextBody>
        <TextBody sx={{ flex: 1, textAlign: "right" }}>
          {noFormat ? date : formatDate(date)}
        </TextBody>
      </View>
    </View>
  );
};

enum StyleName {
  container = "container",
  details = "details",
}

const styles: Record<StyleName, SxProp> = {
  container: {
    flexDirection: "row",
    gap: "$2",
  },
  details: {
    flex: 1,
    paddingY: "$3",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
};
